import { render, staticRenderFns } from "./FeedbackShell.vue?vue&type=template&id=78ec19ee&"
import script from "./FeedbackShell.vue?vue&type=script&lang=js&"
export * from "./FeedbackShell.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackShell.vue?vue&type=style&index=0&id=78ec19ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports